import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Get Clerk publishable key from environment variable
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Clerk provider configuration
const clerkAppearance = {
  variables: {
    colorPrimary: '#a855f7',
    colorBackground: '#1a1a2e',
    colorText: '#ffffff',
    colorInputBackground: 'rgba(255, 255, 255, 0.1)',
    colorInputText: '#ffffff',
    borderRadius: '12px',
  },
  elements: {
    formButtonPrimary: {
      background: 'linear-gradient(135deg, #a855f7, #ec4899)',
      '&:hover': {
        background: 'linear-gradient(135deg, #9333ea, #db2777)',
      },
    },
    card: {
      background: 'rgba(30, 30, 50, 0.95)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    // Make OAuth/social login buttons visible
    socialButtonsBlockButton: {
      background: '#ffffff',
      color: '#1a1a2e',
      border: '1px solid rgba(0, 0, 0, 0.1)',
      '&:hover': {
        background: '#f5f5f5',
      },
    },
    socialButtonsBlockButtonText: {
      color: '#1a1a2e',
      fontWeight: '500',
    },
    socialButtonsProviderIcon: {
      filter: 'none',
    },
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

if (!CLERK_PUBLISHABLE_KEY) {
  root.render(
    <React.StrictMode>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#1a1a2e',
        color: 'white',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <h2>Missing Clerk Publishable Key</h2>
        <p>Please add REACT_APP_CLERK_PUBLISHABLE_KEY to your .env file</p>
      </div>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider
        publishableKey={CLERK_PUBLISHABLE_KEY}
        appearance={clerkAppearance}
      >
        <App />
      </ClerkProvider>
    </React.StrictMode>
  );
}

reportWebVitals();